"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("./colors"));

var _shadows = _interopRequireDefault(require("./shadows"));

var _space = _interopRequireDefault(require("./space"));

var _fontSizes = _interopRequireDefault(require("./fontSizes"));

var util = _interopRequireWildcard(require("./util"));

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

var _button = _interopRequireDefault(require("./button"));

var _iconbutton = _interopRequireDefault(require("./iconbutton"));

var _pill = _interopRequireDefault(require("./pill"));

var _icon = _interopRequireDefault(require("./icon"));

var _list = _interopRequireDefault(require("./list"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var theme = _objectSpread({
  breakpoints: _breakpoints["default"],
  fontSizes: _fontSizes["default"],
  colors: _colors["default"],
  shadows: _shadows["default"],
  space: _space["default"],
  borders: {
    light: "1px solid ".concat(_colors["default"].neutral[200]),
    medium: "1px solid ".concat(_colors["default"].neutral[300])
  }
}, _button["default"], {}, _iconbutton["default"], {}, _pill["default"], {}, _icon["default"], {}, _list["default"]);

theme.util = util;
var _default = theme;
exports["default"] = _default;